import React from 'react'
import styled from 'styled-components'

import Facebook from './Facebook'
import Twitter from './Twitter'
import Instagram from './Instagram'

const ItemContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 206px;
`

const SocialMediaLogo = () => {
  return (
    <ItemContainer>
      <Facebook />
      <Twitter />
      <Instagram />
    </ItemContainer>
  )
}

export default SocialMediaLogo
